import HomeSlider from '@/pages/home/components/slider/HomeSlider.tsx';
import AnyTimeCTA from '@/pages/home/components/anytime/AnyTimeCTA.tsx';
import Diensten from '@/pages/home/components/diensten/Diensten.tsx';
import Features from '@/pages/home/components/features/Features.tsx';
import Pricing from '@/pages/home/components/price/Pricing.tsx';
import OverOns from '@/pages/home/components/overons/OverOns.tsx';
import ContactUs from '@/pages/home/components/contact/ContactUs.tsx';
import Newsletter from '@/pages/home/components/newsletter/Newsletter.tsx';
import LiveChat from '@/pages/home/components/livechat/LiveChat.tsx';

const HomePage = () => {
  return (
    <div>
      <HomeSlider />
      <AnyTimeCTA />
      <Diensten />
      <Features />
      <Pricing />
      <Newsletter />
      <OverOns />
      <ContactUs />
      <LiveChat />
    </div>
  );
};

export default HomePage;
